import "./DayButtons.css"
import { useDispatch } from "react-redux"
import { setDay0, setDay1,setDay2,setDay3,setDay4,setDay5,setDay6,setDay7,setDay8,setDay9 } from "../../actions"


const DayButtons = () => {

    const dispatch = useDispatch()

    const handleClick = (callback, e) => {
        dispatch(callback())
    
        const buttons = document.querySelectorAll(".DayButtons button")
        buttons.forEach(button => button.classList.remove("selected"))
        e.target.classList.add("selected")
      }

    return(
        <div className="DayButtons">
            <button onClick={(e) => handleClick(setDay0,e)} className="dayBtn">Day 0</button>
            <button onClick={(e) => handleClick(setDay1,e)} className="dayBtn">Day 1</button>
            <button onClick={(e) => handleClick(setDay2,e)} className="dayBtn">Day 2</button>
            <button onClick={(e) => handleClick(setDay3,e)} className="dayBtn">Day 3</button>
            <button onClick={(e) => handleClick(setDay4,e)} className="dayBtn">Day 4</button>
            <button onClick={(e) => handleClick(setDay5,e)} className="dayBtn">Day 5</button>
            <button onClick={(e) => handleClick(setDay6,e)} className="dayBtn">Day 6</button>
            <button onClick={(e) => handleClick(setDay7,e)} className="dayBtn">Day 7</button>
            <button onClick={(e) => handleClick(setDay8,e)} className="dayBtn">Day 8</button>
            <button onClick={(e) => handleClick(setDay9,e)} className="dayBtn">Day 9</button>
        </div>
    )
}

export default DayButtons